import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import is from 'is_js';
import BadgeType from 'components/AcademicOverviewBadge/type';
import AcademicOverviewBadge from 'components/AcademicOverviewBadge';

class OverviewBadge extends PureComponent {

  _renderAcademicOverviewBadge(category, num) {
    if (is.existy(num) && num !== 0) {
      const categoryText = `${category}%`;
      return <AcademicOverviewBadge type={BadgeType.WARNING}
          text={categoryText}
          number={num} />;
    }
    return null;
  }

  render() {
    const className = classnames(styles.OverviewBadge, this.props.className);
    if (is.falsy(this.props.studentNumberWithLowerPTScore) &&
      is.falsy(this.props.studentNumberWithLowerSkillScore)) {
      return null;
    }
    return <div className={className}>
      {this._renderAcademicOverviewBadge('PT', this.props.studentNumberWithLowerPTScore)}
      {this._renderAcademicOverviewBadge('SKILL', this.props.studentNumberWithLowerSkillScore)}
    </div>;
  }

}

OverviewBadge.propTypes = {
  studentNumberWithLowerPTScore: PropTypes.number,
  studentNumberWithLowerSkillScore: PropTypes.number,
  className: PropTypes.string,
};

export default OverviewBadge;



// WEBPACK FOOTER //
// ./containers/UserDashboard/AcademicInfo/AcademicInfoGroups/OverviewBadge/index.jsx